/**
 * StatusBar v0.3.1
 *
 * 画面最上部の薄いステータスバー（高さ28px）。
 * 左：● LED + 「SCOUTER ON」 (idle) / 「SCANNING」(SCAN中)
 * 右：現在のモード表示
 *
 * SCAN中はモーダルを閉じても「裏で課金が走り続けている」ことが
 * ステータスバーで一目で分かるよう、accent-orange の点滅ドット +
 * SCANNING ラベルに切り替える。
 */

import type { Mode } from '../types';

import styles from './StatusBar.module.css';

const MODE_DISPLAY: Record<Mode, string> = {
  translate: 'MODE: TRANSLATE',
  summarize: 'MODE: SUMMARIZE',
  interpret: 'MODE: INTERPRET',
};

export interface StatusBarProps {
  mode: Mode;
  /** SCAN（連続認識）が走っているかどうか。true で SCANNING 表示に切り替え */
  isScanning?: boolean;
}

export function StatusBar({ mode, isScanning = false }: StatusBarProps) {
  return (
    <header className={styles.root} role="banner">
      <div className={styles.left}>
        <span
          className={`${styles.led} ${isScanning ? styles.ledScanning : ''}`}
          aria-hidden
        />
        <span className={`${styles.label} ${isScanning ? styles.labelScanning : ''}`}>
          {isScanning ? 'SCANNING' : 'SCOUTER ON'}
        </span>
      </div>
      <div className={styles.right}>{MODE_DISPLAY[mode]}</div>
    </header>
  );
}
